import React from 'react';
import { Modal } from 'react-bootstrap';
// import './DeleteConfirmation.scss';

function DeleteConfirmationGlass({ show, handleClose, handleDelete, title, message, customDeleteButtonText }) {



        return (
            show && (

                <div 
                    className={`glass-effect-popup-overlay ${show && 'show'}`}
                    onClick={handleClose}
                >
                    <div 
                        className={`glass-effect-popup-container md ${show ? 'glassAnimateFadeIn' : 'glassAnimateFadeOut'}`}
                        style={{ display: show ? 'block' : 'none' }}
                        onClick={e => e.stopPropagation()}
                    >
                        {/* <button className="glass-effect-popup-close-icon">&times;</button> */}
                        <button className="btn modal-close-icon text-black" onClick={handleClose}>
                            <svg height="16" width="16" viewBox="0 0 19.295 19.289">
                                <path d="M23.219,20.933l6.891-6.891a1.615,1.615,0,0,0-2.284-2.284L20.935,18.65l-6.891-6.891a1.615,1.615,0,1,0-2.284,2.284l6.891,6.891L11.76,27.825a1.615,1.615,0,1,0,2.284,2.284l6.891-6.891,6.891,6.891a1.615,1.615,0,1,0,2.284-2.284Z" transform="translate(-11.285 -11.289)" />
                            </svg>
                        </button>
                        
                        <div className="glass-effect-popup-content">
                            <div className="row">
                                <div className="col-12 text-center" style={{ marginBottom: '10px' }}>
                                    <svg height="50px" width="50px" clipRule="evenodd" fillRule="evenodd" strokeLinejoin="round" strokeMiterlimit="2" viewBox="0 0 267 267" xmlns="http://www.w3.org/2000/svg" id="fi_15674336"><g transform="matrix(4.167 0 0 4.167 -3000 0)"><path d="m760.291 6.947c-1.704-3.06-4.866-4.947-8.291-4.947s-6.587 1.887-8.291 4.947c-6.619 11.889-15.845 28.459-22.442 40.309-1.697 3.047-1.689 6.794.02 9.833 1.71 3.04 4.861 4.911 8.271 4.911h44.884c3.41 0 6.561-1.871 8.271-4.911 1.709-3.039 1.717-6.786.02-9.833-6.597-11.85-15.823-28.42-22.442-40.309z" fill="#fff"></path><path d="m760.291 6.947c-1.704-3.06-4.866-4.947-8.291-4.947s-6.587 1.887-8.291 4.947c-6.619 11.889-15.845 28.459-22.442 40.309-1.697 3.047-1.689 6.794.02 9.833 1.71 3.04 4.861 4.911 8.271 4.911h44.884c3.41 0 6.561-1.871 8.271-4.911 1.709-3.039 1.717-6.786.02-9.833-6.597-11.85-15.823-28.42-22.442-40.309zm-5.242 2.919 22.442 40.308c.685 1.232.682 2.746-.008 3.974-.633 1.125-1.779 1.852-3.041 1.852h-44.884c-1.262 0-2.408-.727-3.041-1.852-.69-1.228-.693-2.742-.008-3.974 0 0 22.442-40.308 22.442-40.308.631-1.133 1.781-1.866 3.049-1.866s2.418.733 3.049 1.866z" fill="#f00"></path><path d="m752 46.5c1.656 0 3 1.344 3 3s-1.344 3-3 3-3-1.344-3-3 1.344-3 3-3zm2.87-24.003c.034-.783-.253-1.545-.795-2.111s-1.291-.886-2.075-.886c-.784 0-1.533.32-2.075.886s-.829 1.328-.795 2.111c.208 4.769.607 13.958.783 18.006.049 1.117.968 1.997 2.086 1.997h.002c1.118 0 2.037-.88 2.086-1.997.176-4.048.575-13.237.783-18.006z"></path></g></svg>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12 text-center" style={{ marginBottom: '10px', fontSize: '18px' }}>
						            {title || 'Confirm'}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12 text-center" style={{ marginBottom: '10px' }}>
                                    {
                                        message ? (
                                            <div dangerouslySetInnerHTML={{ __html: message }} />
                                        ) : (
                                            <p>Are you sure you want to delete this record?</p>
                                        )
                                    }
                                </div>
                            </div>
					        <div className="popup-content-button-divider"></div>
                            <div className="row">
                                <div className="col-12 text-center">
                                    <div className="modal-actions">
                                        <button
                                            className="btn pm-btn-danger btn-block"
                                            style={{ marginBottom: '7px' }}
                                            onClick={() => {
                                                handleDelete && handleDelete(show.id);
                                            }}
                                        >
                                            {customDeleteButtonText || 'Delete'}
                                        </button>
                                        <button
                                            className="btn pm-btn-default btn-block mt-0"
                                            onClick={(e) => {
                                                handleClose && handleClose(e);
                                            }}
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
    
                        {/* <div className="glass-effect-popup-actions">
                            <button className="btn btn-delete">Yes, Delete Shipment</button>
                            <button className="btn btn-cancel">Cancel</button>
                        </div> */}
                    </div>
                </div>
            )
        )

    // return (
    //     <>
    //         <Modal
    //             show={show}
    //             onHide={(e) => {
    //                 handleClose && handleClose(e);
    //             }}
    //             centered
    //             className="delete-confirmation-dialog"
    //             size="lg"
    //         >
    //             <Modal.Body style={{ marginTop: '-10px', marginBottom: '10px' }}>
    //                 <Modal.Title style={{ marginTop: '10px' }}>
    //                     <span>

    //                         <svg height="50px" width="50px" clipRule="evenodd" fillRule="evenodd" strokeLinejoin="round" strokeMiterlimit="2" viewBox="0 0 267 267" xmlns="http://www.w3.org/2000/svg" id="fi_15674336"><g transform="matrix(4.167 0 0 4.167 -3000 0)"><path d="m760.291 6.947c-1.704-3.06-4.866-4.947-8.291-4.947s-6.587 1.887-8.291 4.947c-6.619 11.889-15.845 28.459-22.442 40.309-1.697 3.047-1.689 6.794.02 9.833 1.71 3.04 4.861 4.911 8.271 4.911h44.884c3.41 0 6.561-1.871 8.271-4.911 1.709-3.039 1.717-6.786.02-9.833-6.597-11.85-15.823-28.42-22.442-40.309z" fill="#fff"></path><path d="m760.291 6.947c-1.704-3.06-4.866-4.947-8.291-4.947s-6.587 1.887-8.291 4.947c-6.619 11.889-15.845 28.459-22.442 40.309-1.697 3.047-1.689 6.794.02 9.833 1.71 3.04 4.861 4.911 8.271 4.911h44.884c3.41 0 6.561-1.871 8.271-4.911 1.709-3.039 1.717-6.786.02-9.833-6.597-11.85-15.823-28.42-22.442-40.309zm-5.242 2.919 22.442 40.308c.685 1.232.682 2.746-.008 3.974-.633 1.125-1.779 1.852-3.041 1.852h-44.884c-1.262 0-2.408-.727-3.041-1.852-.69-1.228-.693-2.742-.008-3.974 0 0 22.442-40.308 22.442-40.308.631-1.133 1.781-1.866 3.049-1.866s2.418.733 3.049 1.866z" fill="#f00"></path><path d="m752 46.5c1.656 0 3 1.344 3 3s-1.344 3-3 3-3-1.344-3-3 1.344-3 3-3zm2.87-24.003c.034-.783-.253-1.545-.795-2.111s-1.291-.886-2.075-.886c-.784 0-1.533.32-2.075.886s-.829 1.328-.795 2.111c.208 4.769.607 13.958.783 18.006.049 1.117.968 1.997 2.086 1.997h.002c1.118 0 2.037-.88 2.086-1.997.176-4.048.575-13.237.783-18.006z"></path></g></svg>
    //                     </span>

    //                     <button
    //                         className="btn modal-close-icon"
    //                         onClick={handleClose}
    //                         style={{ marginTop: '7px' }}
    //                     >
    //                         <svg id="Component_127_1" height="16" width="16" data-name="Component 127 – 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19.295 19.289">
    //                             <path id="Icon_ionic-ios-close" data-name="Icon ionic-ios-close" d="M23.219,20.933l6.891-6.891a1.615,1.615,0,0,0-2.284-2.284L20.935,18.65l-6.891-6.891a1.615,1.615,0,1,0-2.284,2.284l6.891,6.891L11.76,27.825a1.615,1.615,0,1,0,2.284,2.284l6.891-6.891,6.891,6.891a1.615,1.615,0,1,0,2.284-2.284Z" transform="translate(-11.285 -11.289)" />
    //                         </svg>
    //                     </button>
    //                     {title || 'Confirm'}
    //                 </Modal.Title>


    //                 {
    //                     message ? (
    //                         <div dangerouslySetInnerHTML={{ __html: message }} />
    //                     ) : (
    //                         <p>Are you sure you want to delete this record?</p>
    //                     )
    //                 }
    //                 <div className="popup-content-button-divider"></div>
    //                 <div className="modal-actions" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
    //                     <button
    //                         className="btn pm-btn-danger btn-block"
    //                         onClick={() => {
    //                             handleDelete && handleDelete(show.id);
    //                         }}
    //                     >
    //                         {customDeleteButtonText || 'Delete'}
    //                     </button>
    //                     <button
    //                         className="btn pm-btn-default btn-block mt-0"
    //                         onClick={(e) => {
    //                             handleClose && handleClose(e);
    //                         }}
    //                     >
    //                         Cancel
    //                     </button>
    //                 </div>
    //             </Modal.Body>
    //         </Modal>
    //         <div class={`search-overlay popup-overlay ${show && 'show'}`}></div>
    //     </>
    // );
}

export default DeleteConfirmationGlass;
